export function escapeIffAudienceName(audienceName) {
  return audienceName.replace(/([\\),])/g, '\\$1');
}

export function escapeIffInsertText(insertText) {
  return insertText.replace(/([\\)])/g, '\\$1');
}

export function escapeIffDefaultText(defaultText) {
  return defaultText.replace(/([\\}])/g, '\\$1');
}

export function unescapeIff(text) {
  return text.replace(/\\(.)/g, '$1');
}
